/*
    useState
    ---
    Provides a cascading bool state.  Used by components that want to inherit ancestor state. 
*/

import { computed, inject, provide } from 'vue';

const stateProps = () => {
    return {
        state: {
            type: Boolean,
            default: null,
        },
    };
};

function useState(props, isolate) {
    const activeState = computed(() => {
        return props.state;
    });

    provide('state', activeState);
    const ancestorState = inject('state', null);

    const state = computed(() => {
        // console.log('ActiveState: ', activeState.value)
        // console.log('AncestorState: ', ancestorState?.value)
        // State state can be set as property or inherited from nearest ancestor
        return activeState.value || ancestorState?.value;
    });

    return { state };
}

export { useState as default, useState, stateProps };
